<template>
   <Forms ref="frmSearch"
           title="Busca por APR"
           :showHelp="true"
           :showClearButton="true"
           :showSearchButton="true"
           :showNewButton="false"
           :ShowFooterImbo="true"
           :messageTipFooter="$lang.Common.SelectOrEnterInformationToSearch"
           v-on:Clear="onClearSection"
           v-on:Search="Search"
           style="font-family: 'Segoe UI'"
           >
            <div style="width: 100%;">
              <label class="labelsearch">Código da APR</label>
              <b-input v-model="form.Apr"  placeholder="Insira o Número da APR" />
            </div>
            <div style="width: 100%;" class="margem">
              <label class="labelsearch">Atividade</label>
              <select v-model="form.AtividadeId" class="form-control">
                <option :value="null" disabled>Selecione</option>
                <option v-for="data in dataAtividade" :key="data.id" :value="data.id">{{data.descricao}}</option>
              </select>
            </div>

            <div class="form-inputs">
                <label class="labelsearch">Status</label>
                <select v-model="form.status" class="form-control">
                  <option :value="null" disabled>Selecione um status</option>
                  <option v-for="data in statusApr" :key="data.value" :value="data.value">{{data.text}}</option>
                </select>
            </div>

              <div class="labelsearch mt-3" for="txtInsured">Desde</div>
              <div class="margem-buton d-flex align-items-end">
                <b-form-datepicker
                  v-model="form.InicioDataSolicitacao"
                  ref="dataInicio"
                  placeholder="__/__/__"
                  locale="pt-BR"
                  today-button
                  label-today-button="Hoje"
                  reset-button
                  label-reset-button="Limpar"
                  close-button
                  label-close-button="Fechar"
                  :date-format-options="{ year: '2-digit', month: 'numeric', day: 'numeric' }"
                  ></b-form-datepicker>
              </div>
              <label class="labelsearch mt-3" for="txtInsured">Até</label>
              <div class="d-flex align-items-end">
                  <b-form-datepicker
                  v-model="form.FimDataSolicitacao"
                  ref="dataFim"
                  placeholder="__/__/__"
                  locale="pt-BR"
                  today-button
                  label-today-button="Hoje"
                  reset-button
                  label-reset-button="Limpar"
                  close-button
                  label-close-button="Fechar"
                  :date-format-options="{ year: '2-digit', month: 'numeric', day: 'numeric' }"
                  ></b-form-datepicker>
              </div>
   </Forms>
</template>

<script>
import aprReportFiltro from './aprReportFiltro'
export default aprReportFiltro
</script>

<style>
.labelsearch{
  font-weight: 700;
  color: #666;
  font-size: 14px;
  margin-bottom: 5px;
  padding-bottom: 0;
  font-family: Segoe UI;
}
.margem-buton{
  margin-bottom: 0.5rem;
}

.margem{
  margin-top: 0.5rem;
}
</style>



// WEBPACK FOOTER //
// src/views/private/apr/aprReport/components/aprReportTable/components/aprReportFiltro/aprReportFiltro.vue